export default __webpack_public_path__ + "images/QG.c4e415c.png";